import "./App.css";
import "./assets/css/Main.css";
import "./bootstrap.css";
import "./responsee.css";

// import 'sweetalert2/src/sweetalert2.scss'
import { gapi } from "gapi-script";

import { Route, Routes, useLocation } from "react-router-dom";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import MyOrderDetail from "./BuyerDashboardPages/MyOrderDetail";
import MyOrders from "./BuyerDashboardPages/MyOrders";
import TrackOrders from "./BuyerDashboardPages/TrackOrders";
import Wishlist from "./BuyerDashboardPages/Wishlist";
import AboutUs from "./pages/AboutUs";
import AdditionalInformation from "./pages/AdditionalInformation";
import AddReview from "./pages/AddReview";
import AuthScreen from "./pages/AuthPages/AuthScreen";
import ForgotPasswordPage from "./pages/AuthPages/ForgotPasswordPage";
import PassswordMessage from "./pages/AuthPages/PassswordMessage";
import Register from "./pages/AuthPages/Register";
import SetPassword from "./pages/AuthPages/SetPassword";
import VerificationPage from "./pages/AuthPages/VerificationPage";
import Blogs from "./pages/Blogs";
import BlogsDetails from "./pages/BlogsDetails";
import BlogsDetailsCategoryWise from "./pages/BlogsDetailsCategoryWise";
import Campaign from "./pages/Campaign";
import AddCampaign from "./pages/Campaign/AddCampaign";
import UpdateCampaign from "./pages/Campaign/UpdateCampaign";
import Careers from "./pages/Careers";
import CareersMessage from "./pages/CareersMessage";
import Contact from "./pages/Contact";
import Donate from "./pages/Donation/Donate";
import DonateDetails from "./pages/Donation/DonateDetails";
import DonationCategory from "./pages/Donation/DonationCategory";
import DonationSuccessful from "./pages/DonationSuccessful";
import EditReview from "./pages/EditReview";
import AddEvents from "./pages/Events/AddEvents";
import Events from "./pages/Events/Events";
import EventsDetails from "./pages/Events/EventsDetails";
import UpdateEvent from "./pages/Events/updateEvent";
import FAQs from "./pages/FAQs";
import Gratitude from "./pages/Gratitude";
import GratitudeSystem from "./pages/GratitudeSystem";
import Guide from "./pages/Guide";
import Home from "./pages/Home";
import Impact from "./pages/Impact";
import Kyc from "./pages/Kyc";
import Login from "./pages/Login";
import MyEarning from "./pages/MyEarning";
import MyEvents from "./pages/MyEvents";
import NoPage from "./pages/NoPage";
import Notification from "./pages/Notification";
import PayByBank from "./pages/PayByBank";
import PayByCard from "./pages/PayByCard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Profile from "./pages/Profile";
import Referral from "./pages/Referral";
import ReferralList from "./pages/ReferralList";
import RegisterYourBussiness from "./pages/RegisterYourBussiness";
import Settings from "./pages/Settings";
import Sitemap from "./pages/Sitemap";
import TaxInformation from "./pages/TaxInformation";
import TermsAndConditions from "./pages/TermsAndCondtions";
import TransactionHistory from "./pages/TransactionHistory";
import ViewReview from "./pages/ViewReview";
import Wallet from "./pages/Wallet";
import AdminRoute from "./Routes/AdminRoute";
import AuthRoutes from "./Routes/AuthRoutes";
import PrivateRoutes from "./Routes/PrivateRoutes";
import AddProduct from "./SellerDashboardPages/AddProduct";
import AddUserRole from "./SellerDashboardPages/AddUserRole";
import AdminDashboard from "./SellerDashboardPages/AdminDashboard";
import BulkProduct from "./SellerDashboardPages/BulkProduct";
import CompanyDashboard from "./SellerDashboardPages/CompanyDashboard";
import EditProduct from "./SellerDashboardPages/EditProduct";
import EmployeeInvitation from "./SellerDashboardPages/EmployeeInvitation";
import Employees from "./SellerDashboardPages/Employess";
import Order from "./SellerDashboardPages/Order";
import OrderDetail from "./SellerDashboardPages/OrderDetail";
import ProductList from "./SellerDashboardPages/ProductList";
import SellerDashboard from "./SellerDashboardPages/SellerDashboard";
import SellerProfile from "./SellerDashboardPages/SellerProfile";
import TrackOrder from "./SellerDashboardPages/TrackOrder";
import UserRole from "./SellerDashboardPages/UserRole";
import axiosClient from "./Services/Axios/axios";
import Directory from "./SellerDashboardPages/Directory";
import EmployeeInviteLink from "./SellerDashboardPages/EmployeeInviteLink";
import CompanyProfilePage from "./pages/CompanyProfilePage";
import UserEvents from "./pages/Events/UserEvents";

const public_key = process.env.REACT_APP_PUBLIC_KEY;
// Initialize Stripe with your publishable key
const stripePromise = loadStripe(public_key);
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const API_KEY = process.env.REACT_APP_API_KEY;
const SCOPES = process.env.REACT_APP_GOOGLE_SCOPE;

function App() {
  const [businessStatus, setBusinessStatus] = useState("not_registered");
  const location = useLocation();

  const [userData, setUserData] = useState({});
  useEffect(() => {
    const initClient = () => {
      gapi.load("client:auth2", () => {
        gapi.client.init({
          apiKey: API_KEY,
          clientId: CLIENT_ID,
          discoveryDocs: [
            "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
          ],
          scope: SCOPES,
        });
      });
    };
    gapi.load("client:auth2", initClient);
  }, []);

  const handleProfile = async () => {
    try {
      const response = await axiosClient.get(
        `users/${process.env.REACT_APP_API_VERSION}/getByID`
      );
      if (!response.data.error) {
        localStorage.setItem("userData", JSON.stringify(response.data.data));
      }
    } catch (error) {
      console.log(error, "error");
      localStorage.clear();
      // navigation("/");
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    const userNewData = JSON.parse(localStorage.getItem("userData"));
    setUserData(userNewData);
    if (userNewData) {
      handleProfile();
    }
  }, [location.pathname]);
  return (
    <>
      {/* <Header /> */}
      <Routes>
        <Route element={<AuthRoutes />}>
          <Route path="/login" element={<Login />} />
          <Route path="/auth-screen" element={<AuthScreen />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verification" element={<VerificationPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<PassswordMessage />} />
          <Route path="/set-password/:id" element={<SetPassword />} />
          <Route path="/employee-invite/:id" element={<EmployeeInviteLink />} />
        </Route>
        <Route element={<PrivateRoutes />}>
          <Route index element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/donate" element={<Donate />} />
          <Route
            path="/donate-category/:page_url"
            element={<DonationCategory />}
          />
          <Route path="/donate-details/:page_url" element={<DonateDetails />} />
          <Route
            path="/pay-by-bank/:page_url"
            element={
              <Elements stripe={stripePromise}>
                <PayByBank />
              </Elements>
            }
          />
          <Route
            path="/pay-by-card"
            element={
              <Elements stripe={stripePromise}>
                <PayByCard />
              </Elements>
            }
          />

          <Route path="/company-profile" element={<CompanyProfilePage />} />

          <Route path="/donation-successful" element={<DonationSuccessful />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/events" element={<Events />} />
          <Route path="/add-review/:id" element={<AddReview />} />
          <Route path="/edit-review/:id" element={<EditReview />} />
          <Route path="/view-review/:id" element={<ViewReview />} />
          <Route path="/gratitude" element={<Gratitude />} />
          <Route path="/gratitude-system" element={<GratitudeSystem />} />

          <Route path="/referral-list" element={<ReferralList />} />
          <Route path="/events-details/:page_url" element={<EventsDetails />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/instructionfordelete" element={<Guide />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers-message/:id" element={<CareersMessage />} />

          {userData && userData?.id && (
            <>
              <Route path="/profile" element={<Profile />} />
              <Route
                path="/register-your-business"
                element={
                  <RegisterYourBussiness
                    setBusinessStatus={setBusinessStatus}
                  />
                }
              />

              <Route path="/kyc" element={<Kyc />} />
              {/* <Route path="/kyb" element={<Kyc />} /> */}
              <Route path="/tax-information" element={<TaxInformation />} />
              {/* <Route
                path="/additional-information"
                element={<AdditionalInformation />}
              /> */}
              <Route path="/impact" element={<Impact />} />
              {/* <Route path="/myEarning" element ={<MyEarning />} /> */}

              <Route path="/notification" element={<Notification />} />
              {/* {userData?.role_type !== 5 && userData?.role_type !== 7 && ( */}
              <>
                {" "}
                <Route path="/kyb" element={<Kyc />} />
                <Route path="/myEarning" element={<MyEarning />} />
                <Route
                  path="/additional-information"
                  element={<AdditionalInformation />}
                />
                <Route path="/my-orders" element={<MyOrders />} />
                <Route
                  path="/my-orders/my-order-detail/:id"
                  element={<MyOrderDetail />}
                />{" "}
                <Route
                  path="/my-orders/track-orders/:id"
                  element={<TrackOrders />}
                />{" "}
                <Route path="/wishlist" element={<Wishlist />} />
                <Route
                  path="/update-campaign/:id"
                  element={<UpdateCampaign />}
                />
                <Route path="/my-event" element={<MyEvents />} />
                <Route path="/user-event" element={<UserEvents />} />
                <Route path="/add-my-events" element={<AddEvents />} />
                <Route path="/update-my-events" element={<UpdateEvent />} />
              </>
              {/* )} */}

              <Route
                path="/transaction-history"
                element={<TransactionHistory />}
              />
              <Route path="/wallet" element={<Wallet />} />
              <Route path="/referral" element={<Referral />} />
              <Route path="/settings" element={<Settings />} />
            </>
          )}
          {/* {userData &&
            userData?.id &&
            (userData?.role_type === 8 || userData?.role_type === 9) && ( */}
          <>
            <Route element={<AdminRoute />}>
              <Route path="/company-list" element={<CompanyDashboard />} />

              {/* <Route path="/dashboard" 
                  element={<AdminDashboard />} 
                  /> */}

              <Route path="/directory" element={<Directory />} />
              <Route path="/manage-campaign" element={<Campaign />} />
              <Route
                path="/manage-campaign/add-campaign"
                element={<AddCampaign />}
              />

              <Route path="/manage-event" element={<MyEvents />} />
              <Route path="/add-my-events" element={<AddEvents />} />
              <Route path="/update-my-events" element={<UpdateEvent />} />

              <Route path="/mall-dashboard" element={<SellerDashboard />} />

              <Route
                path="/mall-dashboard/bulk-product"
                element={<BulkProduct />}
              />
              <Route path="/track-order" element={<TrackOrder />} />
              <Route path="/seller-profile" element={<SellerProfile />} />
              <Route path="/products" element={<ProductList />} />
              <Route path="/products/add-product" element={<AddProduct />} />
              <Route
                path="/seller-dashboard/product-list/edit-product"
                element={<EditProduct />}
              />
              <Route path="/orders" element={<Order />} />
              <Route
                path="/orders/order-detail/:orderId"
                element={<OrderDetail />}
              />
              <Route path="/employee-role" element={<UserRole />} />
              <Route
                path="/employee-role/manage-access-control/:id"
                element={<AddUserRole />}
              />

              <Route path="/employees" element={<Employees />} />
              <Route
                path="/employees/send-invitaion"
                element={<EmployeeInvitation />}
              />
            </Route>
          </>
          {/* )} */}
          <Route path="/dashboard" element={<AdminDashboard />} />

          <Route path="/news" element={<Blogs />} />
          <Route path="/news-details/:page_url" element={<BlogsDetails />} />
          <Route
            path="/news-details-category-wise/:page_url"
            element={<BlogsDetailsCategoryWise />}
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
      {/* <Footer /> */}
    </>
  );
}

export default App;
